import { Maybe } from 'types/graphqlTypes'

/**
 * @example showCoverageWarning('Tech do not use') // true
 */
export const showCoverageWarning = (carrierName: Maybe<string>) => {
  if (carrierName) {
    const pattern = new RegExp('tech do(.*)', 'i')
    return pattern.test(carrierName || '')
  }
  return false
}
